"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonFileChooser = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _styles = require("./styles");

var _material = require("@mui/material");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../global-files/utils");

var _ButtonV = require("../ButtonV2");

var _jsxRuntime = require("react/jsx-runtime");

var ButtonFileChooser = function ButtonFileChooser(props) {
  var id = props.id,
      key = props.key,
      className = props.className,
      disabled = props.disabled,
      type = props.type,
      transparent = props.transparent,
      label = props.label,
      size = props.size,
      borderType = props.borderType,
      showIcon = props.showIcon,
      _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? "start" : _props$iconPosition,
      isLoading = props.isLoading,
      filters = props.filters,
      multipleFiles = props.multipleFiles,
      onChangeFiles = props.onChangeFiles;

  var openChooser = function openChooser() {
    var files = [];
    var chooser = document.createElement("input");
    chooser.type = "file";
    chooser.style.display = "none";
    if (multipleFiles) chooser.multiple = true;
    if (filters) chooser.accept = filters; // "image/*,text/*,application/*"

    chooser.onchange = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _iterator, _step, file;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator = (0, _createForOfIteratorHelper2.default)(chooser.files);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  file = _step.value;
                  files.push(file);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              onChangeFiles && onChangeFiles(files);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    document.body.appendChild(chooser);
    chooser.click();
    document.body.removeChild(chooser);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
    id: id,
    className: className,
    disabled: disabled,
    isLoading: isLoading,
    type: type,
    transparent: transparent,
    label: label,
    size: size,
    borderType: borderType,
    icon: showIcon ? _freeSolidSvgIcons.faFileUpload : undefined,
    iconPosition: iconPosition,
    onClick: function onClick(event) {
      openChooser();
    }
  }, key);
};

exports.ButtonFileChooser = ButtonFileChooser;